import * as React from "react"
import { Box } from "@chakra-ui/react"
import { Tooltip } from "../../common/tooltip"

const OverflownText = ({ children, ...props }) => {
  const childrenContainer = React.useRef<HTMLDivElement>(null)
  const [isOverflown, setIsOverflown] = React.useState<Boolean>(false)
  React.useEffect(() => {
    if (childrenContainer?.current) {
      setIsOverflown(
        childrenContainer.current?.scrollWidth >
          childrenContainer.current?.clientWidth
      )
    }
  }, [
    childrenContainer?.current?.scrollWidth,
    childrenContainer?.current?.clientWidth
  ])

  return (
    <Tooltip
      label={children}
      isDisabled={!isOverflown}
      zIndex={"tooltip"}
      position="absolute"
    >
      <Box
        position="relative"
        isTruncated
        ref={childrenContainer}
        {...props}
        zIndex={"10000"}
      >
        {children}
      </Box>
    </Tooltip>
  )
}

export { OverflownText }
